
export enum ChargeToCd {
	BOTH = 'Both',
	COLL = 'Coll',
	PPD = 'Ppd',
	VALID_ONLY_FOR_NON_REV_BILLS = 'ValidOnlyForNonRevBills'}

